import React from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import CustomHead from '@components/common/CustomHead/CustomHead';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './InternalError.module.scss';

const InternalError = () => {
    const { t } = useTranslateLpc(['common'], { useSuspense: false });

    return (
        <>
            <CustomHead />
            <div className={css.wrapper}>
                <img className={css.icon__comet} src="/front-static/icons/error-500/comet.svg" alt="comet" />
                <img className={css.icon__star1} src="/front-static/icons/error-500/star.svg" alt="star" />
                <img className={css.icon__star2} src="/front-static/icons/error-500/star.svg" alt="star" />
                <img className={css.icon__earth} src="/front-static/icons/error-500/earth.svg" alt="earth" />
                <img className={css.icon__planet} src="/front-static/icons/error-500/planet.svg" alt="planet" />
                <img
                    className={css.icon__satellite1}
                    src="/front-static/icons/error-500/satellite.svg"
                    alt="satellite"
                />
                <img
                    className={css.icon__satellite2}
                    src="/front-static/icons/error-500/satellite.svg"
                    alt="satellite"
                />
                <img className={css.icon__dizzy} src="/front-static/icons/error-500/dizzy.svg" alt="dizzy" />
                <Text variant={'tagline'} color={'brand-primary'}>
                    {t('internal-server-error.oops')}
                </Text>
                <h1 className={css.title}>{t('internal-server-error.error-500')}</h1>
                <Link href={getRoute(ROUTE.LPC.HOME)}>
                    <Button variant={'primary'} customClass={css.return_button}>
                        {t('internal-server-error.return')}
                    </Button>
                </Link>
            </div>
        </>
    );
};

export default InternalError;
